import React from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

const EServiceItem = ({ service }) => {
  const lang = useSelector((state) => state.mainSlice.lang);
  const item = {
    visible: { opacity: 1, y: 0 },
    hidden: { opacity: 0, y: 150 },
  };
  return (
    <motion.div
      variants={item}
      transition={{ duration: 0.5 }}
      className="col-lg-4 col-md-6 col-sm-12 col-xs-12"
    >
      <img
        src={process.env.REACT_APP_API_URL + service["image"]}
        alt="e-service"
      />
      <h6>
        <Link to={service.url}>
          {lang === "en"
            ? service.name_en
            : lang === "ru"
            ? service.name_ru
            : service.name_tm}
        </Link>
      </h6>
    </motion.div>
  );
};

export default EServiceItem;
